import axios from 'axios';

export default {
  // This method will be deprecated once the datahub method is enhanced with poylgon information.
  loadVoterPrecincts () {
    return new Promise(resolve => {
      axios.get(`https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson`).then((result) => {
        // eslint-disable-next-line
        const headers = Object.keys(result.data.features[0].properties);
        const mappedData = result.data.features.map(m => {
          let obj = {};
          for (let i = 0; i < headers.length; i++) {
            const prop = headers[i];
            const val = m.properties[prop];
            obj[prop] = val;
          }

          obj.coordinates = m.geometry.coordinates[0];

          obj.paths = []
          obj.coordinates.forEach(coord => {
            var latLng = {
              lng: Number(coord[0]),
              lat: Number(coord[1])
            }
            obj.paths.push(latLng);
          })
          return obj;
        });
        const voterPrecincts = mappedData
          .sort((a, b) => { return (a.PREC_NAME < b.PREC_NAME) ? -1 : (a.PREC_NAME > b.PREC_NAME) ? 1 : 0 });
        resolve(voterPrecincts);
      });
    })
  },
  loadCivicAssociations () {
    return new Promise(resolve => {
      axios.get(`https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Civic_Association_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson`).then((result) => {
        // eslint-disable-next-line
        const headers = Object.keys(result.data.features[0].properties);
        const mappedData = result.data.features.map(m => {
          let obj = {};
          for (let i = 0; i < headers.length; i++) {
            const prop = headers[i];
            const val = m.properties[prop];
            obj[prop] = val;
          }

          obj.coordinates = m.geometry.coordinates[0];

          obj.paths = []
          obj.coordinates.forEach(coord => {
            var latLng = {
              lng: Number(coord[0]),
              lat: Number(coord[1])
            }
            obj.paths.push(latLng);
          })
          return obj;
        });
        const civicAssociations = mappedData
          // .filter(m => m.CIVIC && m.CIVIC !== 'Cherry Valley Nature Area')
          .sort((a, b) => { return (a.LABEL < b.LABEL) ? -1 : (a.LABEL > b.LABEL) ? 1 : 0 });
        resolve(civicAssociations);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/service.js